import { Link } from 'react-router-dom';
import { categories } from '@/mocks/tvSeries';

const footerLinks = [
  {
    title: '剧集分类',
    items: categories.slice(0, 5).map((c) => ({
      label: c.name,
      path: `/category/${c.slug}`,
    })),
  },
  {
    title: '更多分类',
    items: categories.slice(5).map((c) => ({
      label: c.name,
      path: `/category/${c.slug}`,
    })),
  },
  {
    title: '关于我们',
    items: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '用户口碑', path: '/about#testimonials' },
      { label: '发展历程', path: '/about#timeline' },
    ],
  },
  {
    title: '帮助中心',
    items: [
      { label: '常见问题', path: '/#faq' },
      { label: '观看指南', path: '/about' },
      { label: '反馈建议', path: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.items.map((item) => (
                    <li key={item.path}>
                      <Link
                        to={item.path}
                        className="text-sm text-background-400 hover:text-background-100 transition-colors"
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/50">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <Link to="/" className="flex items-center gap-2 group">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg transition-transform group-hover:scale-110">
                  <i className="ri-movie-2-line text-background-50 text-base"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50">
                  天美影视
                </span>
              </Link>
              <p className="text-sm text-background-500">
                &copy; {new Date().getFullYear()} 天美影视 tianmeitv.com 版权所有
              </p>
              <div className="flex items-center gap-4">
                <a
                  href="https://weibo.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all"
                  aria-label="微博"
                >
                  <i className="ri-weibo-line text-base"></i>
                </a>
                <a
                  href="https://weixin.qq.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all"
                  aria-label="微信"
                >
                  <i className="ri-wechat-line text-base"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}